import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import {
  createFolioContado,
  createFolioCredito,
  getFoliosBySocialReason,
} from "../../../../services/CatalogService";
import { useNavigate } from "react-router-dom";
import { configFolioSchema } from "../configFolio/formConfigFolio/FolioValidation";
import FolioFields from "./formConfigFolio/FolioFields";

function ConfigFolio() {
  const razonSocial = 'GruasVaro';

  const { Formik } = formik;
  const [initialValues, setInitialValues] = useState({
    folioContado: "",
    folioCredito: "",
  });

  useEffect(() => {
    async function fetchFolios() {
      try {
        const data = await getFoliosBySocialReason(razonSocial);
        const contado = data.find((f) => f.type === "Contado");
        const credito = data.find((f) => f.type === "Credito");
        setInitialValues({
          folioContado: contado?.prefix || "",
          folioCredito: credito?.prefix || "",
        });
      } catch (err) {
        console.error("Error cargando folios existentes", err);
      }
    }

    fetchFolios();
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item active">Folios</li>
          </ol>
          <h1 className="page-header mb-0">Configurar folios</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Registro de Folios</PanelHeader>
            <PanelBody>
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={configFolioSchema}
                onSubmit={async (values, { setSubmitting }) => {
                  try {
                    await Promise.all([
                      createFolioContado({ prefix: values.folioContado }, razonSocial),
                      createFolioCredito({ prefix: values.folioCredito }, razonSocial),
                    ]);

                    Swal.fire({
                      title: "Éxito",
                      text: "Folios guardados correctamente",
                      icon: "success",
                      confirmButtonText: "Cerrar",
                    });
                  } catch (error) {
                    const msg =
                      error.response?.data?.message ||
                      "Error al crear los folios";
                    Swal.fire({
                      title: "Error",
                      text: msg,
                      icon: "error",
                      confirmButtonText: "Cerrar",
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                  <FolioFields
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    values={values}
                    touched={touched}
                    errors={errors}
                  />
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default ConfigFolio;
